import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { RegionUtils } from 'src/app/project/tools/utils/region.utils';
import { Curso } from '../../interfaces/curso';
import { Postulacion } from '../../interfaces/postulacion';
import { Postulante } from '../../interfaces/postulante';
import { PostulacionesService } from '../../services/postulaciones.service';
import { PostulantesService } from '../../services/postulantes.service';
import { animations } from '../../tools/animations';
import { ValidateAge, ValidateReCorreo } from '../../tools/utils/form.validator';
import { ValidateRun } from '../../tools/utils/run.validator';
import { FileUpload } from 'primeng/fileupload';
import { FileUtils } from '../../tools/utils/file.utils';

@Component({
  selector: 'app-form-postulacion',
  templateUrl: './form-postulacion.component.html',
  styleUrls: ['./form-postulacion.component.css'],
  animations: animations
})
export class FormPostulacionComponent implements OnInit {

  private MAX_FILE_SIZE = 5; //SIZE IN MB
  private ID_PAIS_CHILE = 152;
  public nivelesEducacion : any[] = [];
  public preguntasPostulacion : any[] = [];

  public sexos: any[] = [
    { label: 'Masculino', value: 1 },
    { label: 'Femenino', value: 2 },
    { label: 'Otro', value: 3 }
  ];

  public exalumno: any[] = [
    { label: 'Si', value: 'Si' },
    { label: 'No', value: 'No' }
  ];

  public archivoSel: File;
  public fileExtension: string;
  public archivoSel_base64: string;
  public form: FormGroup;
  public codigoAcceso: string;
  public curso_id: number;
  public version: number;
  public curso: Curso;

  public paises: any[] = this.regionUtils.getPaisesDropdown();
  public regiones: any[] = this.regionUtils.getRegionesDropdown();
  public comunas: any[] = [];
  public extranjero: boolean = false;
  public fechaRestriccion: Date;

  public loading: boolean = false;
  public submitted: boolean = false;
  public response = {};
  public postula: boolean = false;

  constructor(
    private postulacionesService: PostulacionesService,
    private postulantesService: PostulantesService,
    private regionUtils: RegionUtils,
    private fileUtils: FileUtils,
    private route: ActivatedRoute
  ) {
    let fecha = new Date();
    fecha.setFullYear(fecha.getFullYear() - 18);
    this.fechaRestriccion = fecha;

    this.curso_id = this.route.snapshot.queryParams.curso_id;
    this.codigoAcceso = this.route.snapshot.queryParams.codigoAcceso;
    this.version = this.route.snapshot.queryParams.version;

    this.cargarNivelesEstudio();
    this.cargarPreguntasPostulacion(this.curso_id);
  }

  regExpInput(pattern, event) {
    const maskSeperator = new RegExp(pattern, 'g');
    let result = maskSeperator.test(event.key); return result;
  } 

  uploadFile(uploader: FileUpload) {
    let imagen_base64 = '';
    this.archivoSel = uploader.files[0];
    let reader: FileReader = new FileReader();
    reader.onload = (e: any) => {
        imagen_base64 = e.target.result;
        this.archivoSel_base64 = e.target.result;
      };

    const extension = this.fileUtils.getFileExtension(uploader.files[0]);
    this.fileExtension = extension;
    if(extension == 'pdf' || extension == 'png' || extension == 'jpg' || extension == 'jpeg'){
      this.form.get('pasaporte').setErrors({ fileExtension: false});
    }else{
      this.form.get('pasaporte').setErrors({ fileExtension: true});
      return;
    }
    
    if(this.fileUtils.getSizeInMegaBytes(uploader.files[0]) > this.MAX_FILE_SIZE){
      this.form.get('pasaporte').setErrors({ maxFileSize: true});
      return;
    }else{
      this.form.get('pasaporte').setErrors({ maxFileSize: false});  
    }
    
    reader.readAsDataURL(uploader.files[0]);
    reader.onloadend = () => {
      if(!this.form.get('pasaporte').hasError('maxFileSize') && !this.form.get('pasaporte').hasError('fileExtension')){  
        this.form.patchValue({pasaporte: imagen_base64});
        this.form.updateValueAndValidity();  
      }
    }

  }

  ngOnInit(): void {


    this.form = new FormGroup({
      run: new FormControl('', [Validators.required, Validators.minLength(8), Validators.maxLength(12), ValidateRun]),
      nroPasaporte: new FormControl('', []),
      pasaporte: new FormControl('', []),
      nombres: new FormControl('', [Validators.required, Validators.minLength(2), Validators.maxLength(35)]),
      paterno: new FormControl('', [Validators.required, Validators.minLength(2), Validators.maxLength(25)]),
      materno: new FormControl('', [Validators.required, Validators.minLength(2), Validators.maxLength(25)]),
      id_sexo: new FormControl('', [Validators.required]),
      fechaNacimiento: new FormControl('', [Validators.required, ValidateAge]), 
      correos: new FormGroup({
        correo: new FormControl('', [Validators.required, Validators.maxLength(100), Validators.pattern(/^[-_a-zA-Z0-9]+(\.[-_a-zA-Z0-9]+)*@[a-zA-Z0-9-]+(\.[a-zA-Z0-9-]+)*(\.[a-zA-Z]{2,4})$/)]),
        reCorreo: new FormControl('',[Validators.required]),  
      }, { validators: ValidateReCorreo}),
      telefono: new FormControl('', [Validators.min(0), Validators.minLength(9), Validators.maxLength(9), Validators.pattern(/^([0-9])*$/)]),
      direccion: new FormControl('', [Validators.maxLength(100)]),
      id_pais: new FormControl(this.ID_PAIS_CHILE, [Validators.required]),
      id_region: new FormControl('', [Validators.required]),
      id_comuna: new FormControl('', [Validators.required]),
      id_nivel_estudios: new FormControl('', [Validators.required]),
      ocupacion: new FormControl('', [Validators.required, Validators.minLength(5), Validators.maxLength(250)]),
      empresa: new FormControl('', [Validators.minLength(5), Validators.maxLength(150)]),
      exalumno: new FormControl('', [Validators.required]),
      preguntaCurso: new FormControl('', [Validators.required, Validators.maxLength(100)])
    });
    
  }

  setExtranjero(e) {
    this.extranjero = e.checked;
    if(this.extranjero){
      this.form.controls['run'].clearValidators();
      this.form.controls['id_region'].clearValidators();
      this.form.controls['id_comuna'].clearValidators();
      this.form.controls['materno'].clearValidators();
      this.form.controls['materno'].setValidators([Validators.minLength(2), Validators.maxLength(25)]);
      this.form.controls['nroPasaporte'].setValidators([Validators.required, Validators.minLength(5), Validators.maxLength(50)]);
      this.form.controls['pasaporte'].setValidators([Validators.required]);
      this.form.patchValue({ id_pais : '' });
      this.form.controls['id_pais'].setValidators([Validators.required]);
    }else{
      this.form.controls['nroPasaporte'].clearValidators();
      this.form.controls['pasaporte'].clearValidators();
      this.form.controls['materno'].clearValidators();
      this.form.controls['materno'].setValidators([Validators.required, Validators.minLength(2), Validators.maxLength(25)]);
      this.form.patchValue({ id_pais : this.ID_PAIS_CHILE });
      this.form.controls['run'].setValidators([Validators.required, Validators.minLength(8), Validators.maxLength(12), ValidateRun]);
      this.form.controls['id_region'].setValidators([Validators.required]);
      this.form.controls['id_comuna'].setValidators([Validators.required]);
    }
    this.form.controls['run'].updateValueAndValidity();
    this.form.controls['pasaporte'].updateValueAndValidity();
    this.form.controls['nroPasaporte'].updateValueAndValidity();
    this.form.controls['materno'].updateValueAndValidity();
    this.form.controls['id_region'].updateValueAndValidity();
      this.form.controls['id_comuna'].updateValueAndValidity();

  }

  cargarComunas() {
    this.comunas = this.regionUtils.getComunasRegionDropdown(this.form.get('id_region').value);
    this.form.get('id_comuna').setValue(null);
  }

  async cargarNivelesEstudio(){
    let nivelesEstudio = await this.postulacionesService.obtenerNivelesEstudio();
    nivelesEstudio.forEach( nivel => {
      this.nivelesEducacion.push({ label: nivel.DESCRIPCION, value: nivel.CODIGO })
    });
  }

  async cargarPreguntasPostulacion(curso_id: number){
    let preguntas = await this.postulacionesService.obtenerPreguntasPostulacion(curso_id);
    preguntas.forEach( pregunta => {      
      this.preguntasPostulacion.push({ label: pregunta.DESCRIPCION, value: pregunta.CODIGO })
    });
    if(preguntas.length == 0){
      this.preguntasPostulacion.push({ label: 'No indicar', value: 'null'});
    }
  }

  comprobarRutExistente(){
    if(!this.form.get('run').errors)
    this.postulantesService.comprobarRunExistente(this.form.value.run.split('-')[0]).then(res => {
      this.form.controls.run.setErrors(res ? {existe: true} : null)          
    });
  }

  comprobarCorreoExistente(){
    if(!this.form.controls.correos.get('correo').errors)
    this.postulantesService.comprobarCorreoExistente(this.form.controls.correos.get('correo').value).then(res => {
      this.form.controls.correos.get('correo').setErrors(res ? {existe: true} : null)    
    });
  }

  comprobarPasaporteExistente(){
    if(!this.form.get('nroPasaporte').errors)
    this.postulantesService.comprobarPasaporteExistente(this.form.value.nroPasaporte).then(res => {
      this.form.controls.nroPasaporte.setErrors(res?.rut ? {existe: true} : null)          
    });
  }

  onSubmit() {
  
    this.submitted = true;
    if( this.form.invalid && (this.form.pristine || this.form.dirty) ){      
      this.form.markAllAsTouched();
    }

    if( this.form.valid ) {
      this.loading = true;
      let postulante = <Postulante>{
        run: this.form.value.run.split('-')[0],
        dv: this.form.value.run.split('-')[1],
        nroPasaporte: this.form.value.nroPasaporte,
        pasaporte: this.form.value.pasaporte,
        nombres: this.form.value.nombres,
        paterno: this.form.value.paterno,
        materno: this.form.value.materno,
        id_sexo: this.form.value.id_sexo,
        fechaNacimiento: this.form.value.fechaNacimiento,
        correo: this.form.get(['correos','correo']).value,
        telefono: this.form.value.telefono,
        direccion: this.form.value.direccion,
        id_pais: this.form.value.id_pais,
        id_region: this.form.value.id_region,
        id_comuna: this.form.value.id_comuna,
        exalumno: this.form.value.exalumno,
        id_nivel_estudios: this.form.value.id_nivel_estudios,
        ocupacion: this.form.value.ocupacion,
        empresa: this.form.value.empresa,
        extranjero: this.extranjero
      };
      let postulacion = <Postulacion>{
        run: postulante.run,
        curso_id: this.curso_id,
        version: this.version,
        medioDifusion: this.form.value.preguntaCurso == 'null' ? null : this.form.value.preguntaCurso
      };      
      this.form.disable();
      this.postulacionesService.ingresarPostulacion(postulante, postulacion).then(res => {
          this.loading = false;
          this.response = res;
          this.postula = true;
        });
      
      
    }
  }



}
